import React from 'react'
import classes from './Loaders.module.scss'

export default function NothingFound() {
  return (
    <div className={classes.nothingFound}>Ничего не найдено</div>
  )
}
